import { render, staticRenderFns } from "./billspay.vue?vue&type=template&id=35c4f6f8&scoped=true&"
import script from "./billspay.vue?vue&type=script&lang=ts&"
export * from "./billspay.vue?vue&type=script&lang=ts&"
import style0 from "./billspay.vue?vue&type=style&index=0&id=35c4f6f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c4f6f8",
  null
  
)

component.options.__file = "billspay.vue"
export default component.exports